import React from 'react';
import { CheckCircle, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { ACCIDENT_GUIDE, COMPANY_INFO } from '../mock';

export const AccidentGuideSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Ratgeber
          </div>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-6 tracking-tight">
            Nach dem Unfall – was jetzt wichtig ist
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Eine klare Checkliste für die wichtigsten Schritte direkt nach einem Unfall
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {ACCIDENT_GUIDE.map((item, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-3xl p-8 hover:border-brand-green/30 hover:shadow-2xl transition-all duration-500">
              <div className="flex items-start gap-5">
                <div className="flex-shrink-0">
                  <div className="w-14 h-14 bg-brand-green/10 rounded-2xl flex items-center justify-center border border-brand-green/15">
                    <CheckCircle className="w-7 h-7 text-brand-green" />
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex items-baseline gap-3 mb-3">
                    <span className="text-brand-green font-bold text-xl">{item.step}.</span>
                    <h3 className="text-xl font-bold text-gray-900 tracking-tight">{item.title}</h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed text-[15px]">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-10 lg:p-16 text-center shadow-2xl">
          <p className="text-gray-300 mb-8 text-lg max-w-2xl mx-auto">
            Bei Schäden über 750€ ist ein unabhängiges Gutachten empfehlenswert. Kontaktieren Sie uns jetzt!
          </p>
          <a href={`tel:${COMPANY_INFO.phone}`}>
            <Button size="lg" className="bg-brand-green hover:bg-brand-green-dark text-white text-lg px-10 py-7 rounded-2xl font-semibold shadow-2xl shadow-brand-green/30">
              <Phone className="w-5 h-5 mr-3" />
              Jetzt anrufen
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};